import React, {Fragment} from 'react';
import PersonIcon from '@mui/icons-material/Person'
import {css} from '@emotion/react';

const cssIcon = css`
	vertical-align: bottom;
	padding-right: 4px;
`
export const EvoAppsUserLabel = ({user, defaultUser}) => {
	// return user.longUsername + " (" + user.text + ", " + user.username + ") " + user.userGroup.id;
	const {username, longUsername, text, userGroup} = user;
	return (
		<Fragment>
			{
				username === defaultUser.username && userGroup.id === defaultUser.userGroup.id &&
				<PersonIcon fontSize={'small'} css={cssIcon}/>
			}
			{
				longUsername +
				(username !== longUsername ? (" [" + username + "]") : "") +
				" - " + text +
				" (" + userGroup.id + " - " + userGroup.description + ")"
			}
		</Fragment>
	);
};